import * as React from "react";
import { usePages, usePage } from "../routes";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Row } from "react-bootstrap";
import { MediaCard } from "../components/shared/MediaCard";
import { Box } from "@mui/material";
import RouteBreadcrumbs from "../components/shared/RouteBreadcrumbs";

export function Home() {
  const { t } = useTranslation();
  const pages = usePages();
  const page = usePage(Home.name);

  return (
    <React.Fragment>
      <RouteBreadcrumbs customPageTitle={`${page?.title} - ${t("home.welcome")}`} />
      <Row className="d-flex justify-content-around">
        {pages
          .filter((page) => page.isMenuItem && page.description)
          .map((page) => (
            <Box margin={4} key={`${page.title}`}>
              <Link to={page.path}>
                <MediaCard
                  id={page.title}
                  title={page.title}
                  icon={page.icon({ size: "5x" })}
                  mainContent={page.description}
                />
              </Link>
            </Box>
          ))}
      </Row>
    </React.Fragment>
  );
}
